import {
  CREATE_BADGE_SUCCESS,
  CREATE_BADGE_ERROR,
  GET_BADGE_SUCCESS,
  GET_BADGE_ERROR,
  ISSUE_BADGE_SUCCESS,
  ISSUE_BADGE_ERROR,
} from '../actions/constants'

const initialState = {
  creatBadgeSuccess: null,
  createBadgeError: [],

  badges: [],
  getBadgesError: [],

  issueBadgeSuccess: null,
  issueBadgeError: [],
}

const create = (state = initialState, { type, payload }) => {
  switch (type) {
    case CREATE_BADGE_SUCCESS:
      return {
        ...state,
        creatBadgeSuccess: payload,
        createBadgeError: [],
      }
    case CREATE_BADGE_ERROR:
      return {
        ...state,
        createBadgeError: payload,
        creatBadgeSuccess: null,
      }
    case GET_BADGE_SUCCESS:
      return {
        ...state,
        badges: payload,
        creatBadgeSuccess: null,
        createBadgeError: [],
        getBadgesError: [],
      }
    case GET_BADGE_ERROR:
      return {
        ...state,
        badges: [],
        creatBadgeSuccess: null,
        createBadgeError: [],
        getBadgesError: payload,
      }
    case ISSUE_BADGE_SUCCESS:
      return {
        ...state,
        issueBadgeSuccess: payload,
        issueBadgeError: [],
      }
    case ISSUE_BADGE_ERROR:
      return {
        ...state,
        issueBadgeError: payload,
        issueBadgeSuccess: null,
      }
    default:
      return state
  }
}

export default create
